import { Latest } from "./latest";


export default () => {
    return <Latest />;
};
